import { H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import React, {useState} from 'react';
import { OrderParcel, Pencil, PercentCircle } from '@zooplus/icons';
import styles from './Benefits.module.scss';
import { Benefit } from './benefit';

export type BenefitsProps = {
  benefitsComboStyles?: boolean;
  firstOrderDiscount?: number
};

export const Benefits = (props: BenefitsProps) => {
  const { t } = useTranslation();
  const [ benefitDiscountKey ] = useState(props.firstOrderDiscount ? 'benefits.discount-fod' : 'benefits.discount-base')

  return (
    <section className={styles.wrapper}>
      <H3 className={styles.title}>{t('benefits.title')}</H3>
      <div
        className={`${styles.benefits} ${props.benefitsComboStyles ? styles.benefitsCombined : ''}`}>
        <Benefit icon={<PercentCircle />} textKey={benefitDiscountKey} percentageToShow={props.firstOrderDiscount?.toString()} />
        <Benefit icon={<Pencil />} textKey={'benefits.adjust'} />
        <Benefit icon={<OrderParcel />} textKey={'benefits.schedule'} />
      </div>
    </section>
  );
};
